import styled from "styled-components";
import { ContainerSmallStyle } from "../../style/Common.style";

export const AboutCompanyStyle = styled.p`
  ${ContainerSmallStyle};

  text-align: center;
`;


